<script setup>

import BaseButton from "@/Components/UI/buttons/BaseButton.vue";
import {router} from "@inertiajs/vue3";
</script>

<template>
    <div v-if="!$page.props.isOnPrem">
        <BaseButton variant="secondary" @click="router.visit(route('payments.index'))" class="text-dark-light fill-dark-light w-full"
                             >
            <svg width="11"
                 height="14"
                 viewBox="0 0 11 14"
                 stroke="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path d="M6.875 8.65002C7.96902 8.65002 9.01823 8.21543 9.79182 7.44184C10.5654 6.66825 11 5.61904 11 4.52502C11 3.43101 10.5654 2.3818 9.79182 1.60821C9.01823 0.834621 7.96902 0.400024 6.875 0.400024H2.75C2.60413 0.400024 2.46424 0.457971 2.36109 0.561116C2.25795 0.664261 2.2 0.804155 2.2 0.950024V7.55002H0.55C0.404131 7.55002 0.264236 7.60797 0.161091 7.71112C0.0579464 7.81426 0 7.95416 0 8.10002C0 8.24589 0.0579464 8.38579 0.161091 8.48893C0.264236 8.59208 0.404131 8.65002 0.55 8.65002H2.2V9.75002H0.55C0.404131 9.75002 0.264236 9.80797 0.161091 9.91112C0.0579464 10.0143 0 10.1542 0 10.3C0 10.4459 0.0579464 10.5858 0.161091 10.6889C0.264236 10.7921 0.404131 10.85 0.55 10.85H2.2V13.05C2.2 13.1959 2.25795 13.3358 2.36109 13.4389C2.46424 13.5421 2.60413 13.6 2.75 13.6C2.89587 13.6 3.03576 13.5421 3.13891 13.4389C3.24205 13.3358 3.3 13.1959 3.3 13.05V10.85H6.6C6.74587 10.85 6.88576 10.7921 6.98891 10.6889C7.09205 10.5858 7.15 10.4459 7.15 10.3C7.15 10.1542 7.09205 10.0143 6.98891 9.91112C6.88576 9.80797 6.74587 9.75002 6.6 9.75002H3.3V8.65002H6.875ZM3.3 1.50002H6.875C7.67728 1.50002 8.4467 1.81873 9.014 2.38603C9.5813 2.95332 9.9 3.72274 9.9 4.52502C9.9 5.3273 9.5813 6.09673 9.014 6.66402C8.4467 7.23132 7.67728 7.55002 6.875 7.55002H3.3V1.50002Z"/>
            </svg>
            Тарифы и оплата
        </BaseButton>
    </div>

</template>
